<template>
  <div class="rich-text-input">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label class="col-form-label"
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
      </label>
      <span v-if="options.required" class="required">*</span>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <textarea class="form-control" type="text"
          :id="options.name"
          @input="validate($event.target.value)"
          :value="value"
          :name="options.name"
          ref="richInput">
        </textarea>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'RichTextInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: '',
          valid: false,
          dirty: false
        }
      }
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      return this.options.label + ' is required'
    }
  },
  data () {
    return {
      isLength: false,
      isRegex: false,
      isValid: false,
      isDirty: false,
      minLength: 3
    }
  },
  mounted () {
    tinymce.remove(`#${this.options.name}`)
    tinymce.init({
      selector: `#${this.options.name}`,
      height: 450,
      forced_root_block: this.options.noTags ? '' : 'p',
      menubar: false,
      statusbar: false,
      plugins: 'table link preview image code template',
      toolbar: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | styleselect formatselect | fontselect fontsizeselect | cut copy paste | bullist numlist | outdent indent | link unlink image | table | template preview code',
      templates: [
        { title: 'Application Approved', url: '/public/templates/application-approved.html' },
        { title: 'Basic Email Template', url: '/public/templates/email-template.html' },
        { title: 'Reservation Confirmation', url: '/public/templates/reservation-confirmation.html' },
        { title: 'Reservation Cancelled', url: '/public/templates/reservation-cancelled.html' }
      ],
      template_replace_values: {
        companyName: '',
        companyPhone: '',
        companyLogo: '',
        homePage: ''
      },
      content_css: '/templates/email-template.css'
    })
  },
  methods: {
    validate () {
      tinymce.triggerSave()
      let val = this.$refs.richInput.value
      this.$emit('input', val)
      this.isDirty = true
      if (val) {
        this.isLength = this.isValid = val.length >= this.minLength
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/RichTextInput.vue